<script>
export default {
    methods: {
        testDataPrefill() {
            const SelectedData = {
                quoteCode: false,
                minAmountUsed: false,
                totalBeforeMinAmount: false,
                translationType: 'basic',
                translateFrom: {
                    flag: "bg",
                    label: "Bulgarian",
                    value: "bulgarian"
                },
                translateTo: {
                    flag: "us",
                    label: "US English",
                    value: "US English"
                },
                turnaround: {
                    "ID": 3,
                    "Name": "48_hour",
                    "HypenName": "48-hour",
                    "FriendlyName": "48 hour",
                    "Available": true,
                    "OvernightAllowed": false,
                    "OvernightPrice": "15",
                    "OvernightWordLimit": "",
                    "OvernightPageLimit": "",
                    "OvernightFrom": "",
                    "OvernightTo": "",
                    "OvernightTimeRange": "all time",
                    "PriceRegular": "0.099",
                    "CentPrice": 9.9,
                    "CentPriceCert": 2697,
                    "PriceCertified": "26.97",
                    "MinRegular": "0",
                    "MinCertified": "22.97",
                    "WordLimit": "2000",
                    "wordLimitCertified": "8",
                    "wordLimitInhouse": "2500",
                    "TimeDisabled": false
                },
                expertise: 'certified',
                numberWords: 7,
                fileUploaded: {
                    name: "1686575318_test.docx",
                    url: "/php_uploads/2023/06/1686575318_test.docx"
                },
                namesPlaces: 'dsad asd asdasd',
                identification: '',
                description: 'dsa dsa dasd as dsad',
                firstName: 'Ivan',
                lastName: 'Obradovic',
                address1: 'Balkanska 29',
                address2: 'apt 2',
                city: 'Kragujevac',
                state: {
                    label: "Alaska",
                    value: "AK"
                },
                zip: '35000',
                country: {
                    label: "Afghanistan",
                    value: "Afghanistan"
                },
                birthday: { mm: '06', dd: '28', yy: '83' },
                confirmBirthday: { mm: '06', dd: '28', yy: '83' },
                email: 'ivanob83gt@gmail.com',
                confirmEmail: 'ivanob83gt@gmail.com',
                cell: '555 5555 555',
                billingData: {
                    paymentType: 'cc',
                    creditCardType: 'Amex',
                    creditCardNumber: '4545454545454545',
                    cvv2Number: '454',
                    expirationDate: { mm: '10', yy: '2028' }
                },
                couponCode: '',
                couponData: {
                    couponCode: ''
                },
                //invoice: 1688400442297,
                invoice: new Date().getTime()
            };
            this.SelectedData = SelectedData;
        }
    }
}
</script>